module.exports = __webpack_public_path__ + "fonts/fontello.48e85f8.ttf";